import QuestionList from 'app/components/tests/layouts/QuestionList';
import * as categoryConst from 'app/constants/categories';
import { AppStoreState } from 'app/redux/store';
import { Question, Passage } from 'types/test';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';

import dynamic from "next/dynamic";
const RightContent = dynamic(() => import("app/components/layouts/MenuRight/RightContent"), { ssr: false });

interface TestMenuProps {
  activeQuestion: (question: Question) => void;
  handleExamScore: () => void;
  initDataTest: () => void;
  numberQuestionDone: number;
  passagesOfUser: Passage[];
}

const TestMenu = (props: TestMenuProps) => {
  const { t } = useTranslation();
  const { test } = useSelector((state: AppStoreState) => state.test);

  const isIeltSpeak = test.category_id == categoryConst.IELT_SPEAK;

  return (
    <RightContent
      title={!isIeltSpeak ? t('tests.list_question') : ''}
      contentRight={!isIeltSpeak ? <QuestionList
        passagesOfUser={props.passagesOfUser}
        numberQuestionDone={props.numberQuestionDone}
        handleExamScore={props.handleExamScore}
        activeQuestion={props.activeQuestion}
        initDataTest={props.initDataTest}
      /> : null}
    />
  )
}

export default TestMenu;
